import UserPersona from './UserPersona';
export default UserPersona;
